var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.00976992 1.87866C0.00976992 1.32638 0.45748 0.878662 1.00977 0.878662H17C17.5523 0.878662 18 1.32638 18 1.87866V13.2029C18 14.3075 17.1046 15.2029 16 15.2029H2C0.89543 15.2029 0 14.3075 0 13.2029V2.20288C0 2.15526 0.00332992 2.10842 0.00976992 2.06257V1.87866ZM2 4.10242V13.2029H16V4.10276L11.1215 8.98127C9.9499 10.1529 8.0504 10.1529 6.87885 8.98127L2 4.10242ZM3.57232 2.84631H14.428L9.7073 7.56707C9.3168 7.95757 8.6836 7.95757 8.2931 7.56707L3.57232 2.84631Z","fill":"#3A9A9F"}));
}

Email.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none"};

module.exports = Email;

Email.default = Email;
